"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.InitProvider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _browserLang = _interopRequireDefault(require("browser-lang"));
var _gatsby = require("gatsby");
var _reactIntl = require("react-intl");
var _intlContext = require("./intl-context");
var _util = require("./util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _process$env = process.env,
  _process$env$GATSBY_I = _process$env.GATSBY_INTL_DEFAULT_LANG,
  GATSBY_INTL_DEFAULT_LANG = _process$env$GATSBY_I === void 0 ? "fr" : _process$env$GATSBY_I,
  GATSBY_INTL_REDIRECT_COMPONENT_PATH = _process$env.GATSBY_INTL_REDIRECT_COMPONENT_PATH;
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};
var polyfillIntl = function polyfillIntl(language) {
  // console.info("polyfillIntl", language)
  var locale = language.split("-")[0];
  try {
    if (!Intl.PluralRules) {
      require("@formatjs/intl-pluralrules/polyfill");
      require("@formatjs/intl-pluralrules/locale-data/" + locale);
    }
    if (!Intl.RelativeTimeFormat) {
      require("@formatjs/intl-relativetimeformat/polyfill");
      require("@formatjs/intl-relativetimeformat/locale-data/" + locale);
    }
  } catch (e) {
    throw new Error("Cannot find react-intl/locale-data/" + language);
  }
};
var InitProvider = exports.InitProvider = function InitProvider(_ref) {
  var _ref$intl = _ref.intl,
    intl = _ref$intl === void 0 ? {} : _ref$intl,
    children = _ref.children;
  // console.info("InitProvider", intl)
  var initialMessages = intl.initialMessages || {};
  var initialFetchNamespaces = (intl.preloadedNamespaces || []).reduce(function (acc, namespace) {
    if (intl.language) {
      acc[intl.language + ":" + namespace] = true;
    }
    return acc;
  }, {});
  var _useState = (0, _react.useState)(initialMessages),
    messages = _useState[0],
    setMessages = _useState[1];
  var _useState2 = (0, _react.useState)(initialFetchNamespaces),
    fetchNamespaces = _useState2[0],
    setFetchNamespaces = _useState2[1];
  var addMessages = function addMessages(newMsg) {
    var availableKeys = Object.keys(newMsg).filter(function (k) {
      return newMsg[k] !== messages[k];
    });
    if (availableKeys.length > 0) {
      setMessages(function (msg) {
        return (0, _extends2.default)({}, msg, newMsg);
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: (intl === null || intl === void 0 ? void 0 : intl.language) || GATSBY_INTL_DEFAULT_LANG,
    defaultLocale: (intl === null || intl === void 0 ? void 0 : intl.defaultLanguage) || GATSBY_INTL_DEFAULT_LANG,
    messages: messages,
    onError: function onError() {
      //
    }
  }, /*#__PURE__*/_react.default.createElement(_intlContext.IntlContextProvider, {
    value: (0, _extends2.default)({}, intl, {
      addMessages: addMessages,
      fetchNamespaces: fetchNamespaces,
      setFetchNamespaces: setFetchNamespaces
    })
  }, children));
};
var withIntlProvider = function withIntlProvider(intl) {
  return function (children) {
    // console.info("withIntlProvider", intl)
    polyfillIntl((intl === null || intl === void 0 ? void 0 : intl.language) || GATSBY_INTL_DEFAULT_LANG);
    return /*#__PURE__*/_react.default.createElement(InitProvider, {
      intl: intl,
      children: children
    });
  };
};
var _default = exports.default = function _default(_ref2, pluginOptions) {
  var element = _ref2.element,
    props = _ref2.props;
  if (!props) {
    return;
  }
  var pageContext = props.pageContext,
    location = props.location;
  var defaultLanguage = pluginOptions.defaultLanguage;
  var intl = (0, _extends2.default)({
    language: GATSBY_INTL_DEFAULT_LANG,
    languages: [GATSBY_INTL_DEFAULT_LANG]
  }, pageContext.intl || {});
  // console.info("intl", intl)
  var language = intl.language,
    languages = intl.languages,
    redirect = intl.redirect,
    routed = intl.routed,
    originalPath = intl.originalPath,
    redirectDefaultLanguageToRoot = intl.redirectDefaultLanguageToRoot,
    ignoredPaths = intl.ignoredPaths,
    fallbackLanguage = intl.fallbackLanguage;
  if (typeof window !== "undefined") {
    window.___gatsbyIntl = intl;
  }
  /* eslint-disable no-undef */
  var isRedirect = redirect && !routed;
  if (isRedirect) {
    var search = location.search;

    // Skip build, Browsers only
    if (typeof window !== "undefined") {
      // Check if the current path starts with an invalid language code
      var pathSegments = window.location.pathname.split('/').filter(Boolean);
      var firstSegment = pathSegments[0];
      var hasInvalidLanguagePrefix = firstSegment && !languages.includes(firstSegment);

      // If the URL has an invalid language prefix, don't redirect - preserve the original URL
      if (hasInvalidLanguagePrefix) {
        isRedirect = false;
      } else {
        var detected = window.localStorage.getItem("gatsby-intl-language") || (0, _browserLang.default)({
          languages: languages,
          fallback: fallbackLanguage || language
        });
        if (!languages.includes(detected)) {
          detected = language;
        }
        var isMatchedIgnoredPaths = (0, _util.isMatch)(ignoredPaths, window.location.pathname);
        isRedirect = !(redirectDefaultLanguageToRoot && detected === defaultLanguage) && !isMatchedIgnoredPaths;
        if (isRedirect) {
          var queryParams = search || "";
          var newUrl = "/" + detected + originalPath + queryParams;
          window.localStorage.setItem("gatsby-intl-language", detected);
          (0, _gatsby.navigate)(newUrl, {
            replace: true
          });
          // browser should render redirect element
          var _renderElement = GATSBY_INTL_REDIRECT_COMPONENT_PATH && /*#__PURE__*/_react.default.createElement(preferDefault(require(GATSBY_INTL_REDIRECT_COMPONENT_PATH)));
          return withIntlProvider(intl)(_renderElement);
        }
      }
    }
  }
  var renderElement = isRedirect && !redirectDefaultLanguageToRoot ? GATSBY_INTL_REDIRECT_COMPONENT_PATH && /*#__PURE__*/_react.default.createElement(preferDefault(require(GATSBY_INTL_REDIRECT_COMPONENT_PATH))) : element;
  return withIntlProvider(intl)(renderElement);
};